import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';

const SunEditorUI = ({ content, onChange }) => {
    return (
        <SunEditor
            onChange={onChange}
            setContents={content ? content : ''}
            setOptions={{
                height: 500,
                // buttonList: buttonList.complex
                buttonList: [
                    ['undo', 'redo'],
                    ['font', 'fontSize', 'formatBlock'],
                    ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                    ['removeFormat'],
                    ['fontColor', 'hiliteColor'],
                    ['outdent', 'indent'],
                    ['align', 'horizontalRule', 'list'],
                    ['link'] // 'table', 'image', 'video', 'save' buttons are omitted
                ]
            }}
        />
    )
}

export default SunEditorUI;